import styled from '@emotion/styled';

const NearByAreasWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 16px;
  margin: 0 -16px;

  @media (min-width: ${(props) => props.theme.breakpoints.tablet_landscape}) {
    margin: 0 -${(props) => props.theme.padding};
    padding: 0 ${(props) => props.theme.padding};
  }

  .items {
    display: flex;
    flex-wrap: wrap;
  }

  .header {
    margin-bottom: 16px;
    margin-top: 0;

    @media (min-width: ${(props) => props.theme.breakpoints.tablet_landscape}) {
      margin-bottom: 24px;
    }
  }

  .more-button {
    background: transparent;
    border-color: transparent;
    color: ${(props) => props.theme.colors.primary};
    font-weight: bold;
    border-bottom: 3px solid ${(props) => props.theme.colors.yellow._400};
    padding: 0;
    width: fit-content;
    line-height: 16px;
    cursor: pointer;
  }
`;

const ExpandListButton = styled.span`
  display: inline-block;
  padding: 8px;
  cursor: pointer;

  &:after {
    content: '';
    display: block;
    border-top: 2px solid #4a4a4a;
    border-right: 2px solid #4a4a4a;
    -webkit-transform: rotate(135deg);
    -ms-transform: rotate(135deg);
    transform: rotate(135deg);
    width: 8px;
    height: 8px;
    transition: transform 0.2s ease-in-out;
  }

  &.expanded:after {
    -webkit-transform: rotate(-45deg);
    -ms-transform: rotate(-45deg);
    transform: rotate(-45deg);
  }
`;

const Item = styled.span`
  font-family: Inter;
  font-size: 14px;
  line-height: 16px;
  margin-right: 25px;
  margin-bottom: 16px;
  position: relative;

  a {
    color: ${(props) => props.theme.colors.primary};
    text-decoration: underline;
  }
`;

export { NearByAreasWrapper, ExpandListButton, Item };
